import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import home from '@/views/home.vue'

import login from '@/views/login.vue'
import addgoods from '@/views/add-goods.vue'
import sliderPath from './sliderPath.js'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: sessionStorage.login ? 'home' :'login'
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        name: '登录',
        icon: '',
        auth: false
      },
      component: login
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        name: '首页',
        icon: '',
        auth: true
      },
      component: home,
      children: sliderPath
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js